// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Competition from "./competition.js"
import FeedbackSurvey from "./feedback-survey.js"
import Survey from "./survey.js"
import TeamSurvey from "./team-survey.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_id": {
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": false,
        "type": "uuid"
      },
      "name": "team_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_to_feedback_id": {
      "column": {
        "default": null,
        "name": "team_survey_to_feedback_id",
        "null": false,
        "type": "uuid"
      },
      "name": "team_survey_to_feedback_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "FeedbackAssignment",
  "collectionKey": "feedback_assignments",
  "collectionName": "feedback_assignments",
  "i18nKey": "feedback_assignment",
  "camelizedLower": "feedbackAssignment",
  "name": "FeedbackAssignment",
  "nameDasherized": "feedback-assignment",
  "pluralName": "feedback_assignments",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team_survey"
    },
    {
      "className": "FeedbackSurvey",
      "collectionName": "feedback_surveys",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_survey",
      "macro": "has_one",
      "resource_name": "FeedbackSurvey",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "owners",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "team_survey"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_survey_id",
      "column": {
        "default": null,
        "name": "old_team_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_survey_to_feedback_id",
      "column": {
        "default": null,
        "name": "old_team_survey_to_feedback_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "team_survey_id",
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "team_survey_to_feedback_id",
      "column": {
        "default": null,
        "name": "team_survey_to_feedback_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team_survey"
    },
    {
      "className": "FeedbackSurvey",
      "collectionName": "feedback_surveys",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_survey",
      "macro": "has_one",
      "resource_name": "FeedbackSurvey",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    }
  ],
  "paramKey": "feedback_assignment",
  "primaryKey": "id"
}

/** Frontend model for FeedbackAssignment. */
export default class FeedbackAssignment extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  teamSurveyId() {
    return this.readAttributeUnderscore("team_survey_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyId() {
    const value = this.teamSurveyId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  teamSurveyToFeedbackId() {
    return this.readAttributeUnderscore("team_survey_to_feedback_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyToFeedbackId() {
    const value = this.teamSurveyToFeedbackId()

    return this._isPresent(value)
  }

  /** @returns {import("./competition.js").default | null} */
  competition() {
    return this._readHasOneReflection({modelClass: Competition, reflectionName: "competition"})
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  loadCompetition() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "competition",
        model: this,
        modelClass: Competition
      },
      {
        params: {
          through: {
            model: "FeedbackAssignment",
            id,
            reflection: "competition"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  ensureCompetitionLoaded() {
    return this.ensureAssociationLoaded("competition")
  }

  /** @returns {import("./feedback-survey.js").default | null} */
  feedbackSurvey() {
    return this._readHasOneReflection({modelClass: FeedbackSurvey, reflectionName: "feedback_survey"})
  }

  /** @returns {Promise<import("./feedback-survey.js").default | null>} */
  loadFeedbackSurvey() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["feedback_assignment_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "feedback_survey",
        model: this,
        modelClass: FeedbackSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./feedback-survey.js").default | null>} */
  ensureFeedbackSurveyLoaded() {
    return this.ensureAssociationLoaded("feedback_survey")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readHasOneReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {
        params: {
          through: {
            model: "FeedbackAssignment",
            id,
            reflection: "survey"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurvey() {
    return this._readBelongsToReflection({modelClass: TeamSurvey, reflectionName: "team_survey"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurvey() {
    if (!("teamSurveyId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyId")

    const id = this.teamSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyLoaded() {
    return this.ensureAssociationLoaded("team_survey")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurveyToFeedback() {
    return this._readBelongsToReflection({modelClass: TeamSurvey, reflectionName: "team_survey_to_feedback"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurveyToFeedback() {
    if (!("teamSurveyToFeedbackId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyToFeedbackId")

    const id = this.teamSurveyToFeedbackId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey_to_feedback",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyToFeedbackLoaded() {
    return this.ensureAssociationLoaded("team_survey_to_feedback")
  }
}
